export default "__VITE_ASSET__CGEyr43R__"